module.exports = __webpack_public_path__ + "static/media/3DPPA36.7f90d55e.jpg";